import { useEffect, useState } from "react";
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
// import { retentionTagObj } from "../../pages/engagement/retention/Nightingale/_config";
import { shallowEqual, useSelector } from "umi";
import { gePcRetentionTrend } from "@/pages/dashboard/services/engagement";
import { retentionTagObj } from "../../Nightingale/_config";
import { getApiData } from "@/pages/dashboard/services/common";


const useData = (api:string,filterVal: any, filterLoading: boolean, tag: string) => {
  const { gameCode } = useSelector((state: any) => {
    return {
      gameCode: state?.dashboard?.currentGame?.game_code,
    };
  }, shallowEqual);

  const [componentData, setComponentData] = useState<any>({
    avg_d1: '',
    avg_d2: '',
    avg_d3: '',
    avg_d7: '',
    d1: [],
    d2: [],
    d3: [],
    d7: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  // 点击筛选器的时候
  useEffect(() => {
    if (!filterVal) return;
    !filterLoading && getRetentionTrendDataFunc();
  }, [filterVal, tag]);


  const getRetentionTrendDataFunc = () => {
    const { rangeTime, diff, timeType,rangeDaily,...filters } = filterVal;
    // const { , ...filters } = filterVal;
    const params = {
      game_code: gameCode,
      start_time: rangeTime?.[0], // 不用补齐日期
      end_time: rangeTime?.[1],
      // 
      tag,
      // tag: 'new',
      cycle: 'day',
      filters: formatFilterValues(filters),
    };
    setLoading(true);
    // api
    getApiData(api,params).then((result: any) => {
      setLoading(false);
      setError(false);
      setComponentData(result);
    }).catch((err: any) => {
      setError(true);
      setLoading(false);
    });
  };

  return {
    // nodata 不在此封装，因为可能是接口的个别项目nodata
    componentData,
    loading,
    error,
  };
};

export default useData;